module.exports = __webpack_public_path__ + "img/jmlogo_black.b704d9a3.png";